// extracted by css-extract-rspack-plugin
export default {"appSwitcher":"mWAj5"};